import { render } from "./ListeMandaturePage.vue?vue&type=template&id=78a4c980&ts=true"
import script from "./ListeMandaturePage.vue?vue&type=script&lang=ts"
export * from "./ListeMandaturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__